import React from 'react';

const NotificationSkeleton: React.FC = () => {
  return (
    <div className="flex items-start gap-4 border-b py-4">
      <div className="skeleton-block rounded-lg" style={{ width: 32, height: 32 }} />
      <div className="grow">
        <div className="flex items-center mb-2 gap-2">
          <div className="skeleton-block rounded-lg" style={{ width: 160, height: 20 }} />
          <div className="skeleton-block rounded-lg ml-4" style={{ width: 96, height: 16 }} />
        </div>
        <div className="skeleton-block rounded-lg w-full mb-2" style={{ height: 16 }} />
        <div className="skeleton-block rounded-lg" style={{ width: '75%', height: 16 }} />
      </div>
    </div>
  );
};

export default NotificationSkeleton;
